import type React from 'react';
import type { StylesConfig } from 'react-select';
import AsyncSelect from 'react-select/async';

import { Field, type FieldProps } from 'formik';

import {
  mergeSelectStyles,
  reactSelectMenuPortalProps,
} from '../select/reactSelectTheme';

interface Option {
  value: string;
  label: string;
}

interface AutocompleteFieldProps {
  name: string;
  label?: string;
  required?: boolean;
  loadOptions: (inputValue: string) => Promise<Option[]>;
  placeholder?: string;
  options: Option[];
  onChange?: (value: string, option: Option | null) => void;
  isLoading?: boolean;
}

export const AutocompleteField: React.FC<AutocompleteFieldProps> = ({
  name,
  label,
  required,
  loadOptions,
  options,
  placeholder = 'Начните вводить...',
  onChange,
  isLoading = false,
}) => {
  const customStyles: StylesConfig<Option, false> = mergeSelectStyles<Option, false>({
    // prod1: 16px как у остальных полей (было 15px и бледный #A7A7A7 - плохо читалось).
    input: () => ({
      color: '#0f1418',
    }),
  });

  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <div className='form-field'>
          {label && (
            <label className='label'>
              <span className='labelText'>{label}</span>
              {required && <span className='requiredLabelMarker'>*</span>}
            </label>
          )}

          <AsyncSelect<Option, false>
            cacheOptions
            defaultOptions={options}
            loadOptions={loadOptions}
            name={field.name}
            value={options.find((option) => option.value === field.value) || null}
            onChange={(selectedOption) => {
              const value = selectedOption?.value || '';
              const option = selectedOption;

              form.setFieldValue(name, value);

              if (onChange) {
                onChange(value, option);
              }
            }}
            onBlur={field.onBlur}
            placeholder={placeholder}
            styles={customStyles}
            isLoading={isLoading}
            loadingMessage={() => 'Загрузка...'}
            noOptionsMessage={() => 'Ничего не найдено'}
            {...reactSelectMenuPortalProps}
            components={{
              IndicatorSeparator: () => null,
            }}
          />
        </div>
      )}
    </Field>
  );
};
